module.exports = __webpack_public_path__ + "img/info.002.4c62dcbc.jpeg";